import { ZAttribute } from "src/types/ZAttribute";
import { StoreFinancialInput } from "./StoreFinancialInput";
import { StoreFinancialInputStd } from "./StoreFinancialInputStd";

export const createStoreFinancialInput = (
  attr: ZAttribute,
): StoreFinancialInput => new StoreFinancialInputStd(attr);
